"use client";

import { useEffect, useState } from "react";
import { Button, InputField } from "@vionixasia/shared-components";
import { AdminShell } from "@/components/AdminShell";
import { apiClient } from "@/lib/api-client";
import { useQueryParam } from "@/lib/use-query-param";
import type { WhatsAppLog } from "@/types/whatsapp";

export default function WhatsAppLogsPage() {
  const projectId = useQueryParam("projectId");
  const eventId = useQueryParam("eventId");
  const [logs, setLogs] = useState<WhatsAppLog[]>([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");

  async function load() {
    if (!projectId || !eventId) return;
    const query = new URLSearchParams();
    if (search) query.set("search", search);
    if (status) query.set("status", status);
    const data = await apiClient<{ logs: WhatsAppLog[] }>(`/api/projects/${projectId}/events/${eventId}/whatsapp-logs?${query.toString()}`);
    setLogs(data.logs);
  }

  useEffect(() => {
    load();
  }, [projectId, eventId]);

  return (
    <AdminShell>
      <h1 className="text-2xl font-semibold text-ink">WhatsApp Logs</h1>
      <div className="mt-5 flex flex-wrap items-end gap-3 rounded-card border border-line bg-white p-4">
        <InputField wrapperClassName="min-w-[240px] flex-1" label="Search" name="search" placeholder="Phone / runner" value={search} onChange={(e) => setSearch(e.target.value)} labelColor="text-ink" />
        <InputField wrapperClassName="min-w-[200px]" label="Status" name="status" type="select" value={status} onChange={(e) => setStatus(e.target.value)} labelColor="text-ink" defaultOptionLabel={null}>
          <option value="">All status</option>
          {["queued", "sent", "delivered", "read", "failed"].map((item) => <option key={item} value={item}>{item}</option>)}
        </InputField>
        <Button color="teal" onClick={load}>Apply</Button>
      </div>
      <div className="table-scroll mt-5 rounded-card border border-line bg-white">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-surface text-muted">
            <tr>{["Runner Name", "Phone", "Template", "Status", "Provider Message ID", "Error", "Sent At", "Updated At"].map((label) => <th key={label} className="px-3 py-2 font-medium">{label}</th>)}</tr>
          </thead>
          <tbody>{logs.map((log) => (
            <tr key={log.id} className="border-t border-line">
              <td className="px-3 py-2 font-medium">{log.runner_name}</td>
              <td className="px-3 py-2">{log.phone_number}</td>
              <td className="px-3 py-2">{log.template_name}</td>
              <td className="px-3 py-2">{log.status}</td>
              <td className="px-3 py-2">{log.provider_message_id || "-"}</td>
              <td className="px-3 py-2 text-red-700">{log.error_message || "-"}</td>
              <td className="px-3 py-2">{log.created_at ? "created" : "-"}</td>
              <td className="px-3 py-2">{log.updated_at ? "updated" : "-"}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </AdminShell>
  );
}
